export default __webpack_public_path__ + "static/media/growth-icon.60b7bc68.svg";